export default __webpack_public_path__ + "static/media/PDFReport-Cover.79ed6a88.png";